// removed by extract-text-webpack-plugin
module.exports = {"basic":"_32Ugi5h_v0BoRzGhopjoY-","link":"_32QGvBajcTidE-k3V87zL8"};


//////////////////
// WEBPACK FOOTER
// ./src/css/components/button.css
// module id = 168
// module chunks = 0